/// <amd-module name="VSS/Platform/RestClient/Contributions" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as Contributions from "../Contracts/Contributions";

import { IContributionsRestClient } from "VSS/Platform/RestClient/Contributions.Types";

export { IContributionsRestClient } from "VSS/Platform/RestClient/Contributions.Types";

class ContributionsRestClient extends RestClientBase implements IContributionsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param query - 
     * @param scopeName - 
     * @param scopeValue - 
     */
    public async queryDataProviders(
        query: Contributions.DataProviderQuery,
        scopeName?: string,
        scopeValue?: string
        ): Promise<Contributions.DataProviderResult> {

        return this.beginRequest<Contributions.DataProviderResult>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Contribution/dataProviders/query/{scopeName}/{scopeValue}",
            routeValues: {
                scopeName: scopeName,
                scopeValue: scopeValue
            },
            body: query
        });
    }

}

export const ContributionsClientName = "IContributionsRestClient";

export function getContributionsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IContributionsRestClient {
    return pageContext.getRestClient<IContributionsRestClient>(ContributionsClientName, options);
}

RestClients.add(ContributionsClientName, { 
    factory: ContributionsRestClient
});
